import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PERMISSION_STATES } from '@models/permission.class';
import { SelectedPuppetTab } from '@models/puppet.class';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map, pluck, takeUntil } from 'rxjs/operators';
import { AppState, USER_ROLES } from 'src/app';
import { selectCurrentContract } from 'src/app/state/selectors/current-contract.selectors';
import { GeolocationService } from 'src/core';

@Component({
  selector: 'hb-trade-bar',
  templateUrl: './tradeBar.component.html',
  styleUrls: ['./tradeBar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TradeBarComponent implements OnInit, OnDestroy {
  public isUsaContract = false;

  selectedTab: SelectedPuppetTab = SelectedPuppetTab.TRADE;
  public operations = true;
  public userRoleSubscription: Subscription;
  public userGlobalSubscription: Subscription;
  public isUserAdmin = false;
  public isGlobalContract = false;

  public isPositionMocked$: Observable<boolean>;

  public shouldRestrictTradeOperations$: Observable<boolean>;
  public shouldNotifyGeolocationOnOperationAttempt$: Observable<boolean>;

  private tradeType: string[] = ['capital', 'funds', 'cash'];

  private operationControl: any = {
    capital: true,
    funds: true,
    cash: true,
  };

  private selectedOrder: any = { id: '1', name: 'Limitada' };

  private destroyed$: Subject<void> = new Subject<void>();
  private currentContract: string;

  constructor(
    private store: Store<AppState>,
    private geolocationService: GeolocationService,
  ) {}

  ngOnInit() {
    this.scanForUserRole();
    this.scanForUserTypeContract();
    this.scanForSelectedTab();
    this.scanForUsaContract();
    this.checkShouldRestrictGeolocationRelatedActions();
    this.isPositionMocked$ = this.store.select('serviceInterruption').pipe(
      filter((state) => state !== undefined),
      map((e: any) => e.toJS()),
      pluck('position'),
    );
  }

  ngOnDestroy() {
    [this.userRoleSubscription, this.userGlobalSubscription]
      .filter((subscription) => !!subscription)
      .forEach((subscription) => subscription.unsubscribe());

    this.destroyed$.next();
  }

  scanForUserRole() {
    this.userRoleSubscription = this.store
      .select('userRole')
      .pipe(filter((value: any) => value !== undefined))
      .subscribe((value: any) => {
        this.isUserAdmin = value === USER_ROLES.SUBDIRECTOR;
      });
  }

  scanForUserTypeContract() {
    this.userGlobalSubscription = this.store
      .select('userGlobal')
      .subscribe((value: any) => {
        this.isGlobalContract = value;
        this.validateCashTab();
      });
  }

  scanForSelectedTab() {
    this.store
      .select('puppet')
      .pipe(map((value: any) => value.toJS()))
      .subscribe((puppetUI: { selectedTab: SelectedPuppetTab }) => {
        this.changeView(puppetUI.selectedTab);
      });
  }

  checkShouldRestrictGeolocationRelatedActions() {
    this.shouldNotifyGeolocationOnOperationAttempt$ =
      this.geolocationService.permissionsState$
        .asObservable()
        .pipe(map((state) => state !== PERMISSION_STATES.granted));

    this.shouldRestrictTradeOperations$ =
      this.geolocationService.shouldRestricGeolocationRelatedOperations$;
  }

  changeOperationStatus(key: string, value: boolean) {
    this.operationControl[key] = !value;
  }

  onChangeOrderType(selectedOrder: any) {
    this.selectedOrder = selectedOrder;
  }

  changeView(index: SelectedPuppetTab): void {
    this.selectedTab = index;
    if (index === 1) {
      const key = this.tradeType[index];
      this.operationControl[key] = false;
    }
  }

  validateCashTab(): void {
    if (this.selectedTab === 2 && this.isGlobalContract) {
      this.changeView(0);
    }
  }

  private scanForUsaContract() {
    this.store
      .select(selectCurrentContract)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((currentContract) => {
        this.currentContract = currentContract.contractID;
        this.isUsaContract = currentContract.isUsa;
      });
  }
}
